import AudioManager from 'scripts/util/AudioManager';
import * as BABYLON from 'babylonjs'

class IcePatch {
  constructor (mesh, mesh2) {
    const index =  Math.round(Math.random() * 1000)
    this.view = new BABYLON.TransformNode('IcePatch' + index)
    this.view.rotationQuaternion = null
    
    this.mesh = mesh
    this.mesh.parent = this.view
    this.mesh.rotationQuaternion = null
    this.mesh2 = mesh2
    this.mesh2.parent = this.view
    this.mesh2.rotationQuaternion = null
    this.isHit = false

    this.collider = BABYLON.MeshBuilder.CreateBox("IcePatchCollider" + index, {width: 1.5, size: 1.2});
    this.collider.position.y = .5
    this.collider.parent = this.view
    this.collider.isVisible = false
  } 

  setConfig(config) {
    this.config = config
    
    const {position, rotation, scaling} = this.config
    
    this.view.rotation = rotation.clone()
    this.view.position = position.clone()
    this.view.scaling = scaling.clone()
    this.mesh.scaling = new BABYLON.Vector3(config.scaling.x*10,config.scaling.y*10,config.scaling.z*10)
    this.mesh2.scaling = new BABYLON.Vector3(config.scaling.x*10,config.scaling.y*10,config.scaling.z*10)
  }

  hit () {
    this.isHit = true
  }

  reset () {
    this.mesh.isVisible = true
    this.mesh2.isVisible = true
    this.isHit = false
  }

  destroy() {
    this.collider.parent = null
    this.collider.isVisible = false
    this.collider.dispose()

    this.mesh.parent = null
    this.mesh.isVisible = false
    this.mesh.dispose()
    this.mesh2.isVisible = false
    this.mesh2.dispose()

    this.view.parent = null
    this.view.isVisible = false
    this.view.dispose()
  }
}

export default IcePatch